/**
 * Every URL key the listings filter sheet can write (draftToParams in
 * components/listings/ListingsFilterPanel.tsx). A host that opens the
 * sheet over its own state, like the alert form, replaces exactly these
 * on apply and keeps the rest (text search, drawn area, its own fields).
 * tests/unit/filter-panel-keys.test.mjs fails when the sheet writes a
 * key that is missing here or in PANEL_CARRIED_KEYS.
 */
export const PANEL_PARAM_KEYS: readonly string[] = [
  "leased", "viewed", "source", "category", "building_type", "listing_kind",
  "price_min", "price_max", "rooms", "area_min", "area_max", "sot_min", "sot_max", "pps_min", "pps_max",
  "floor_min", "floor_max", "exclude_first_floor", "exclude_last_floor",
  // The number of floors: a flat's building, a house's storeys (ticket 63).
  "total_floors_min", "total_floors_max",
  "has_repair", "photo_condition", "photo_has", "tags", "has_mortgage", "mortgage_kind", "max_initial",
  "mortgage_rate_min", "mortgage_rate_max", "mortgage_terms_known", "mortgage_years",
  "listed_after", "listed_before", "has_bill_of_sale", "seller_type",
  "location_ids", "deal_tier", "complex_slug", "developer", "street", "city", "rent_period", "metro_walk",
  "center_lat", "center_lng", "radius_km",
  // The deed-area filter from PR #470, listed ahead so whichever of the
  // two merges second keeps the alert form's apply exact.
  "deed_gap",
  "min_yield",
  // Commercial premises and garages (2026-10-21): the kind chips and the
  // price per m² their sheet shows.
  "property_kind", "ppm_min", "ppm_max",
  // What the listing's own text says (lib/text-facts, backend
  // services/text_facts): the facts picked under the deed and in the
  // sheet's topics.
  "fact",
];

/**
 * Keys the sheet has no control for but hands back unchanged, so a host
 * that rebuilds its URL from the sheet's output (the listings page, the
 * map, the Telegram app) keeps them (ticket 68: the drawn area fell off
 * on apply). A host that keeps its own copy, like the alert form, skips
 * them when it merges the sheet's output.
 */
export const PANEL_CARRIED_KEYS: readonly string[] = ["draw"];
